import React from 'react'

import FormSign from '../../components/Login/FormSign'

import '../styles/main.css'

function Main() {

    return (

        <main className='--main'>

            <div className='--content-main--login'>

                <div className='--box-main--login'>

                    <div className='--col-main--login'></div>

                    <div className='--col-main--login'>

                        <div className='--col-main--login-center'>
                        
                            <h1>Crea tu cuenta</h1>
                            <p>¡Hola! Accede y encuentra el trabajo que buscas</p>

                            <div className='--line'></div>
                        
                            <FormSign/>

                        </div>

                    </div>

                </div>

            </div>

        </main>

    )

}

export default Main